import {subtle} from '@rambler-id/crypto'

const buckets = [
  100,
  500,
  2000,
  5000,
  8000,
  12000,
  16000,
  20000,
  30000,
  50000,
  100000,
  300000,
  500000,
  1000000,
  Infinity
]

export default function testSha1(index = 1, time = performance.now()) {
  return subtle
    .digest('SHA-1', new TextEncoder('utf-8').encode(`shateststring${index}`))
    .then(() => {
      if (performance.now() - time >= 1000) {
        return buckets.find((b) => index <= b)
      }

      return testSha1(index + 1, time)
    })
}
